import { Box } from '@factorialco/deprecated-design-system'
import { AvailableModules, Features } from 'generated/featureDefinitions'
import { ProcurementSettingsPageDocument } from 'generated/resources/graphql'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useQuery } from 'modules/core/hooks/useQuery'
import i18n from 'modules/core/lib/i18n'

import ApprovalsBlock from 'modules/approvals/components/ApprovalsConfigurationBlock'
import { ResponsivePage } from 'modules/layout/components/ResponsivePage'
import { RequestTypeSettingsBlock } from 'modules/procurement/components/procurementTypes/RequestTypeSettingsBlock'
import NewProcurementSettingsContent from 'modules/procurement/components/settings/NewProcurementSettingsContent'
import SettingsCollectionsBootstrap from 'modules/procurement/lib/SettingsCollectionsBootstrap'

const PurchaseRequestsSettingsPage = () => {
  const { company } = useCurrentSession()

  const { data, error, loading } = useQuery(ProcurementSettingsPageDocument, {
    variables: {
      companyId: company.id,
      moduleId: AvailableModules.procurement,
      featureId: Features.procurement_purchase_requests,
    },
  })

  const canView = !!data?.procurement._policies.settingsManage.can
  const requestTypes = data?.procurement.typesConnection.edges?.map((e) => e.node) || []
  const purchaseRequestsfeatureEnabled =
    data?.companies.featureAvailabilitiesConnection.edges[0]?.node?.available ?? false
  const isProcurementV2FeatureEnabled = !!data?.features?.featuresConnection?.edges?.some(
    (e) => e.node.name === 'procurement_v2' && e.node.enabled
  )
  const canReadTaskForms = data?.procurement?._policies?.procurementTaskFormRead?.can ?? false
  const canCreateTaskForms = data?.procurement?._policies?.procurementTaskFormCreate?.can ?? false
  const isPoTemplatesFeatureEnabled = !!data?.features?.poTemplatesFeature?.edges?.some(
    (e) => e.node.name === 'dev_procurement_po_templates' && e.node.enabled
  )

  return (
    <SettingsCollectionsBootstrap>
      <ResponsivePage.Body
        authorized={canView && purchaseRequestsfeatureEnabled}
        loading={loading}
        error={error}
        height="full"
      >
        {isProcurementV2FeatureEnabled ? (
          <NewProcurementSettingsContent
            canReadTaskForms={canReadTaskForms}
            canReadPoTemplates={isPoTemplatesFeatureEnabled}
            canCreateTaskForms={canCreateTaskForms}
          />
        ) : (
          <>
            <Box width="full" alignItems="flexEnd" justifyContent="flexEnd" paddingY="s24">
              <ApprovalsBlock
                noPadding
                category="purchases"
                title={i18n.t('procurement.purchase_requests.settings.approvals.title')}
                description={i18n.t('procurement.purchase_requests.settings.approvals.description')}
              />
            </Box>
            <RequestTypeSettingsBlock requestTypes={requestTypes} />
          </>
        )}
      </ResponsivePage.Body>
    </SettingsCollectionsBootstrap>
  )
}

export default PurchaseRequestsSettingsPage
